import Vue from 'vue'
import MQ from 'vue-match-media/src'

Vue.use(MQ)

import './index.scss'

import Cookie from './partials/Cookie'
import CreateNav from './partials/CreateNav'
import CreateFooter from './partials/CreateFooter'

Vue.component('hero', require('./components/Hero').default)
Vue.component('hero-image', require('./components/HeroImage').default)
Vue.component('quarter-and-box', require('./components/QuarterAndBox').default)
Vue.component('quarter-and-video', require('./components/QuarterAndVideo').default)
Vue.component('centre-and-box', require('./components/CentreAndBox').default)
Vue.component('three-columns', require('./components/ThreeColumns').default)
Vue.component('fifty-fifty', require('./components/FiftyFifty').default)
Vue.component('thirds', require('./components/Thirds').default)
Vue.component('fifty-logos', require('./components/FiftyLogos').default)
Vue.component('stats', require('./components/Stats').default)
Vue.component('hub', require('./components/Hub').default)

let content = {}
let router = {}
if (process.env.ROUTER !== 'wp') {
  content = require('./content.json')

  const VueRouter = require('vue-router').default
  Vue.use(VueRouter)

  const Home = require('./pages/Home.vue').default
  const Hub = require('./pages/Hub.vue').default
  const NewHome = require('./pages/NewHome.vue').default
  const Hygeine = require('./pages/Hygeine.vue').default

  router = new VueRouter({
    mode: 'history',
    routes: [
      { path: '/', redirect: '/home' },
      { path: '/home', component: Home },
      { path: '/new', component: NewHome, props: { content } },
      { path: '/hub', component: Hub, props: { content } },
      { path: '/hygeine', component: Hygeine }
    ]
  })
}

new Vue({
  el: '#app',
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1024px)'
  },
  components: {
    Cookie,
    CreateNav,
    CreateFooter
  },
  data: {
    content
  },
  router
})



// WEBPACK FOOTER //
// ./index.js